import { __rest } from "tslib";
import * as Sentry from '@sentry/react';
import * as frontEndRouter from './insights/frontendEventRouter';
import * as googleAnalytics from './insights/googleAnalytics';
const sendToFullstory = (type, data) => {
    if (window.fsWrapper) {
        window.fsWrapper(type, data);
    }
    else {
        Sentry.captureException(new Error('Fullstory not available'));
    }
};
const create = () => {
    googleAnalytics.create();
};
const pageview = (pathname = '/', search = '', title) => {
    sendToFullstory('trackEvent', {
        name: 'page-view',
        properties: {
            pathname,
            search,
            title
        }
    });
    googleAnalytics.pageview();
    frontEndRouter.pageview(pathname, search, title);
};
const setUser = userData => {
    sendToFullstory('setIdentity', {
        uid: userData.user_id
    });
    googleAnalytics.setUser(userData);
    frontEndRouter.setUser(userData, userData.tokenHelper);
};
const setRealm = realm => {
    sendToFullstory('setProperties', {
        type: 'page',
        properties: {
            realm
        }
    });
    googleAnalytics.setRealm(realm);
    frontEndRouter.setRealm(realm);
};
const data = (custom = {}) => {
    sendToFullstory('setProperties', {
        type: 'page',
        properties: custom
    });
    googleAnalytics.data(custom);
};
const event = (eventData) => {
    const { action, customData } = eventData, restEventData = __rest(eventData, ["action", "customData"]);
    sendToFullstory('trackEvent', {
        name: action !== null && action !== void 0 ? action : 'event',
        properties: Object.assign(Object.assign({}, restEventData), customData)
    });
    googleAnalytics.event(eventData);
    frontEndRouter.events(eventData);
};
const logException = (action = {}) => {
    googleAnalytics.logException(action);
};
const trackSidebarNavigation = ({ label }) => {
    event({
        action: 'navigation',
        category: 'menu-sidebar',
        label
    });
};
export { create, data, event, logException, pageview, setRealm, setUser, trackSidebarNavigation };
